import { type FunctionComponent } from 'react';

import i18n from 'i18n/i18n';
import { type DunningSelectionForecast } from 'interfaces/Interfaces';

interface DunningForecastTableProps {
  forecast: DunningSelectionForecast;
}

const DunningForecastTable: FunctionComponent<DunningForecastTableProps> = ({ forecast }) => (
  <>
    <p className="card-subtitle">
      {i18n.t('dunning-forecast.forecasted-for', {
        date: new Date(forecast.forecastedDate).toLocaleDateString(i18n.language),
      })}
    </p>
    <table>
      <thead>
        <tr>
          <th>{i18n.t('dunning-forecast.actions')}</th>
          <th>{i18n.t('dunning-forecast.total')}</th>
          <th>{i18n.t('dunning-forecast.selected')}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{i18n.t('dunning-forecast.notifications')}</td>
          <td>{forecast.withoutDunningSelection.notifications}</td>
          <td>{forecast.withDunningSelection.notifications}</td>
        </tr>
        <tr>
          <td>{i18n.t('dunning-forecast.disconnection-threats')}</td>
          <td>{forecast.withoutDunningSelection.disconnectionsThreat}</td>
          <td>{forecast.withDunningSelection.disconnectionsThreat}</td>
        </tr>
        <tr>
          <td>{i18n.t('dunning-forecast.disconnection-announcements')}</td>
          <td>{forecast.withoutDunningSelection.disconnectionsAnnouncement}</td>
          <td>{forecast.withDunningSelection.disconnectionsAnnouncement}</td>
        </tr>
        <tr>
          <td>{i18n.t('dunning-forecast.disconnections')}</td>
          <td>{forecast.withoutDunningSelection.disconnections}</td>
          <td>{forecast.withDunningSelection.disconnections}</td>
        </tr>
        <tr>
          <td>{i18n.t('dunning-forecast.terminations')}</td>
          <td>{forecast.withoutDunningSelection.contractTermination}</td>
          <td>{forecast.withDunningSelection.contractTermination}</td>
        </tr>
        <tr>
          <td>{i18n.t('dunning-forecast.debt-collection')}</td>
          <td>{forecast.withoutDunningSelection.debtCollection}</td>
          <td>{forecast.withDunningSelection.debtCollection}</td>
        </tr>
        <tr>
          <td>{i18n.t('dunning-forecast.cancel-debt-collection')}</td>
          <td>{forecast.withoutDunningSelection.cancelDebtCollection ?? 0}</td>
          <td>{forecast.withDunningSelection.cancelDebtCollection ?? 0}</td>
        </tr>
        <tr>
          <td>{i18n.t('dunning-forecast.change-of-level')}</td>
          <td>{forecast.withoutDunningSelection.changeOfLevel ?? 0}</td>
          <td>{forecast.withDunningSelection.changeOfLevel ?? 0}</td>
        </tr>
        <tr className="dunning-forecast__row--bold">
          <td>{i18n.t('dunning-forecast.total-actions')}</td>
          <td>{forecast.withoutDunningSelection.total}</td>
          <td>{forecast.withDunningSelection.total}</td>
        </tr>
        <tr className="dunning-forecast__row--bold">
          <td>{i18n.t('dunning-forecast.total-contracts-affected')}</td>
          <td>{forecast.withoutDunningSelection.totalContractsAffected ?? 0}</td>
          <td>{forecast.withDunningSelection.totalContractsAffected ?? 0}</td>
        </tr>
        <tr className="dunning-forecast__row--bold">
          <td>{i18n.t('dunning-forecast.total-open-amount')}</td>
          <td>{forecast.withoutDunningSelection.totalOpenAmount} €</td>
          <td>{forecast.withDunningSelection.totalOpenAmount} €</td>
        </tr>
      </tbody>
    </table>
    <p className="card-description">{i18n.t('dunning-forecast.description')}</p>
  </>
);

export default DunningForecastTable;
